
import { nuestrosCorosVideoCarousel } from '../components/carousel'
import SplitText from "../components/splitText";

window.addEventListener("load", function () {
  new SplitText(".video-title");
  new SplitText(".video-subtitle");
  nuestrosCorosVideoCarousel()
  loadCarouselAOS()
});

declare var AOS: any

const loadCarouselAOS = () => {
  const slideALL = document.querySelectorAll(".swiper-slide") as NodeListOf<HTMLElement>
  let count = 0
  slideALL.forEach((slide)=> {
    slide.setAttribute("data-aos", "fade-up")
    slide.setAttribute("data-aos-duration", "1000")
    slide.setAttribute("data-aos-delay", `${count}`)
    count += 200
  })

  AOS.init({
    once: true,
  })

}
